export default __webpack_public_path__ + "static/media/LineBg.40e8e612.svg";